import axios from "axios";
import { API_HOST } from "../main";

export default {
  getAll: callback => {
    axios
      .get(`${API_HOST}/api/v1/labels/`)
      .then(response => callback(null, response.data))
      .catch(e => callback(e, null));
  }
};
